module.exports = __webpack_public_path__ + "img/8f57a26.png";